import React from "react";

import { PlainButton, classnames } from "@culturehq/components";
import { AWSLanguage, Subtitle } from "chq";
import { Trans } from "app/utils";

interface SubtitleTabProps {
  activeLanguage?: string;
  changingLanguage?: boolean;
  loading?: boolean;
  onLanguageChange: (subtitle: Subtitle | AWSLanguage) => void;
  subtitle: Subtitle | AWSLanguage;
}

const SubtitleTab: React.FC<SubtitleTabProps> = ({
  activeLanguage,
  changingLanguage,
  loading,
  onLanguageChange,
  subtitle
}) => (
  <li role="navigation">
    <PlainButton
      className={classnames(
        { active: activeLanguage === subtitle.label || activeLanguage === subtitle.transcription }
      )}
      disabled={changingLanguage}
      onClick={() => { onLanguageChange(subtitle); }}
    >
      {subtitle.label || subtitle.transcription}
      {loading && (
        <>
          {" "}
          <i><Trans>(processing)</Trans></i>
        </>
      )}
    </PlainButton>
  </li>
);

export default SubtitleTab;
